import { useState, useCallback } from 'react';
import { getSourceFiles, Movie } from '../lib/api_config';
export const useMovieList = (deviceID: string) => {
  const [movieList, setMovieList] = useState<Movie[]>([]);
  // const [nextToken, setNextToken] = useState<any>(null);
  // const [currentPage, setCurrentPage] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>();
  const [error, setError] = useState<string>('');

  const fetchMovieList = useCallback(async ({pageSize, startDate, endDate, reverse = false}:{pageSize?: string|number,startDate?: string, endDate?: string, reverse?: boolean}) => {
    setLoading(true);
    try {
      const {
        movieList: list,
        // nextToken: nt
      } = await getSourceFiles({deviceID, pageSize, startDate, endDate, nextToken: null});

      setMovieList(reverse ? list.reverse(): list);
      // setNextToken(nt);
    } catch (error) {

      if( error instanceof Error) {
        setError(error.message);
      }

    }
    setLoading(false);
  }, [deviceID]);
  return { state: { movieList, loading, error}, actions: { fetchMovieList, setMovieList  } };
};